<template>
  <div class="video_content">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" :finished-text="hasVideo ? '没有更多了':''" @load="onLoad">
        <div class="videoList" :style="{minHeight: minHeight}" v-if="hasVideo">
          <van-row gutter="12">
            <van-col span="12" class="video_item" v-for="(item,index) in videoList" :key="'b'+index"
              @click="goPlay(item)">
              <div class="video_img_box">
                <img class="videoImg" :src="item.video_cover[0]">
                <img v-if="item.is_top == 1" class="upTopImg" src="../../../assets/house/upTopTip.png">
                <div class="video_shadow">
                  <div class="video_shadow_left">
                    <img class="video_shadow_left_img" src="../../../assets/house/video_shadow_play.png" alt="">
                    <span class="video_shadow_left_txt">{{item.screen_num}}</span>
                  </div>
                </div>
              </div>
              <div class="video_item_bottom">
                <p class="video_item_title">{{item.title}}</p>
                <div class="video_item_bottom_like">
                  <span class="video_item_bottom_like_left">{{item.publisher}}</span>
                  <div class="video_item_bottom_like_right" @click.stop="handleLike(item)">
                    <img v-if="item.video_fabulous != null" class="video_item_bottom_like_img"
                      src="../../../assets/house/video_like.png" alt="">
                    <img v-else class="video_item_bottom_like_img" src="../../../assets/house/videoDislike.png" alt="">
                    <span
                      :class="[item.video_fabulous != null?'video_item_bottom_like_right_dislike_txt':'video_item_bottom_like_right_like_txt']">{{item.likes_num}}</span>
                  </div>
                </div>
              </div>
            </van-col>
          </van-row>
          <template v-if="videoList.length%2>0">
            <div class="video_Noitem" v-for="(item,i) in (2-videoList.length%2)" :key="i">
            </div>
          </template>
        </div>
      </van-list>
      <div v-if="!hasVideo" class="videoList_noLen">
        <img v-if="!hasVideo" class="no_video" src="../../../assets/house/no_video.png" alt="">
        <p v-if="!hasVideo" class="noVideo_txt">暂无相关视频</p>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
  import Bus from '@/providers/eventBus.js';

  export default {
    name: 'videoContent',
    data() {
      return {
        refreshing: false,
        loading: false,
        finished: false,
        page: 0,
        pageSize: 10,
        videoList: [],
        hasVideo: false,
        minHeight: 0,
      }
    },
    props: {
      id: {
        type: Number,
      },
    },
    mounted() {
      Bus.$on('__updateVideoItem', (item) => {
        let _temp = this.videoList.find(_ => _.id == item.id);
        if (_temp) {
          if (_temp.video_fabulous) {
            _temp.video_fabulous = null;
            _temp.likes_num--;
          } else {
            _temp.video_fabulous = {};
            _temp.likes_num++;
          }
        }
      })
    },
    methods: {
      setMinHeight() {
        let tab_pane = document.querySelector('.van-tab__pane');
        this.minHeight = tab_pane.clientHeight + 'px';
      },
      getVideoList(group_id, page, pageSize) {
        this.$api.post('estate/member/video/zone/list', {
          group_id,
          page,
          pageSize
        }).then(res => {
          if (this.refreshing) {
            this.videoList = []
            this.finished = false
          }
          this.videoList.push(...res.list)
          if (this.videoList.length === 0) {
            this.hasVideo = false
          } else {
            this.hasVideo = true
            this.$nextTick(() => this.setMinHeight());
          }
          if (this.videoList.length === 0 || res.length === 0) {
            this.finished = true
            this.loading = false
            this.refreshing = false
            return
          }
          this.loading = false
          if (res.current_page === res.last_page) {
            this.finished = true;
          }
          if (this.refreshing) {
            this.$toast("刷新成功");
            this.refreshing = false;
          }
          if (!this.finished && !this.loading && this.videoList.length <= 2) {
            this.onLoad();
          }
        }).catch((err) => {
          this.loading = false;
          this.finished = true;
          this.refreshing = false
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          }
          return;
        })
      },
      onRefresh() {
        this.page = 0
        this.onLoad();
      },
      onLoad() {
        this.page++;
        this.getVideoList(this.id, this.page, this.pageSize);
      },
      handleLike(item) {
        this.$api
          .post("estate/member/video/zone/likes", {
            id: item.id
          })
          .then((res) => {
            if (item.video_fabulous) {
              this.$toast("取消成功", 1000);
              item.video_fabulous = null;
              item.likes_num--;
            } else {
              this.$toast("点赞成功", 1000);
              item.video_fabulous = {};
              item.likes_num++;
            }
          });
      },
      goPlay(item) {
        item.screen_num += 1;
        this.$router.push({
          path: '/house/player',
          query: {
            id: item.id,
            token: this.$route.query.token
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .video_content {
    height: 100%;
    overflow: auto;
  }

  .videoList {
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    // justify-content: space-between;
    padding: 0 16px;
    padding-bottom: 10px;

    &::-webkit-scrollbar {
      display: none;
    }

    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .videoList_noLen {
    height: 100%;
    padding-bottom: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .video_item {
    height: 214px;
    margin-top: 12px;
    border-radius: 8px;
    box-shadow: 0px 4px 16px 0px rgba(206, 208, 213, 0.44);
  }

  .video_Noitem {
    width: 166px;
    height: 214px;
    margin-top: 12px;
    border-radius: 8px;
  }

  .video_img_box {
    // width: 166px;
    width: 100%;
    height: 132px;
    position: relative;
  }

  .videoImg {
    // width: 166px;
    width: 100%;
    height: 132px;
    border-radius: 8px 8px 0px 0px;
  }

  .upTopImg {
    position: absolute;
    top: 0;
    left: 0;
    width: 36px;
    height: 20px;
  }

  .video_shadow {
    // width: 166px;
    width: 100%;
    height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    border-radius: 8px 8px 0px 0px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
  }

  .video_shadow_left {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 12px;
  }

  .video_shadow_left_img {
    width: 12px;
    height: 12px;
    margin-right: 3px;
  }

  .video_shadow_left_txt {
    font-size: 12px;
    color: #F5F5F5;
  }

  .video_item_bottom {
    // width: 166px;
    width: 100%;
  }

  .video_item_title {
    font-size: 12px;
    font-weight: bold;
    line-height: 15px;
    color: #333333;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    height: 30px;
    width: 150px;
    padding: 12px 8px 0;
  }

  .video_item_bottom_like {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 8px;
    // padding-bottom: 12px;
  }

  .video_item_bottom_like_left {
    font-size: 12px;
    color: #999999;
  }

  .video_item_bottom_like_right {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .video_item_bottom_like_img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .video_item_bottom_like_right_like_txt {
    font-size: 12px;
    color: #999999;

    line-height: 14px;
  }

  .video_item_bottom_like_right_dislike_txt {
    font-size: 12px;
    color: #FF704F;

    line-height: 14px;
  }

  .no_video {
    width: 160px;
    height: 160px;
    margin-top: 30px;
  }

  .noVideo_txt {
    font-size: 14px;
    color: #969799;
  }
</style>